<template>
    <div class="row p-1 table-row">
        <div class="col-3 d-flex flex-column justify-content-center">
            <small>{{ moment(entry.date_start).format("MM-DD-YY") }}</small>
            <small v-if="entry.date_end">- {{ moment(entry.date_end).format("MM-DD-YY") }}</small>
        </div>
        <div class="col-4">
            <div class="row">
                <div class="col-3">
                    <img
                        :src="
                            specialists.find(s => s.id === entry.specialist).profile_photo_url ||
                                '../../images/default_user.jpeg'
                        "
                        class="profile-image"
                    />
                </div>
                <div class="col-9 d-flex flex-column justify-content-center">
                    <small>{{ specialists.find(s => s.id === entry.specialist).name }}</small>
                    <small>{{ specialists.find(s => s.id === entry.specialist).phone }}</small>
                    <small
                        ><a
                            :href="
                                `mailto:${specialists.find(s => s.id === entry.specialist).email}`
                            "
                            class="link"
                        ></a
                        >{{ specialists.find(s => s.id === entry.specialist).email }}</small
                    >
                </div>
            </div>
        </div>
        <div class="col-4 d-flex flex-column justify-content-center">
            <small>{{ entry.service }}</small>
        </div>
        <div class="col-1">
            <div class="h-100 d-flex justify-content-center align-items-center cursor-pointer">
                <i
                    class="fa fa-edit text-primary cursor-pointer mr-2"
                    @click="editEntry(entry)"
                ></i>
                <i
                    class="fa fa-times-circle-o text-primary cursor-pointer"
                    @click="deleteEntry(entry)"
                ></i>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "TimelineEntry",
    props: ["entry", "specialists"],
    methods: {
        editEntry(e) {
            this.$emit("edit-entry", e);
        },
        deleteEntry(e) {
            let endpoint = "";
            axios
                .delete(`${endpoint}${e.id}`)
                .then(r => {
                    this.newData = {};
                    this.editing = false;
                    this.getData();
                })
                .catch(e => {
                    console.error(e);
                });
        },
    },
};
</script>

<style scoped lang="scss">
.table-row:not(:last-child) {
    background-color: #ffffff;
    border: solid 1px #bfbfbf;
    border-bottom: none;
}
.table-row:last-child {
    background-color: #ffffff;
    border: solid 1px #bfbfbf;
}
.profile-image {
    min-width: 3rem;
    max-width: 3rem;
    min-height: 3rem;
    max-height: 3rem;
}
</style>
